export default [{
    path: '/calculator',
    name: 'calculator',
    component: () => import('./containers/calculator/index'),
    children: []
},{
    path: '/light-calculator',
    name: 'ics_calculator',
    component: () => import('./containers/LightCalculator'),
    children: []
}, {
    path: '/report/:id',
    name: 'report',
    component: () => import('./containers/report/index'),
    children: []
},{
    path: '/view-shared-report/:id',
    name: 'view_shared_report',
    component: () => import('./containers/report/index'),
    children: []
}, {
    path: '/output-pdf/:id',
    name: 'print_report',
    component: () => import('./containers/pdf-report/index'),
    children: []
}, {
    path: '/report-light/:id',
    name: 'report_light',
    component: () => import('./containers/ReportLight'),
    children: []
}, {
    path: '/history',
    name: 'history',
    component: () => import('./containers/History'),
    children: []
},{
    path: '/shared-reports',
    name: 'shared_reports',
    component: () => import('./containers/SharedReports'),
    children: []
},{
    path: '/request-valuation',
    name: 'request_valuation',
    component: () => import('./containers/RequestValuation'),
    children: []
}, {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('./containers/Home'),
    children: []
}, {
    path: '/reports',
    name: 'reports',
    component: () => import('./containers/Reports'),
    children: []
}, {
    path: '/new-valuation',
    name: 'new_valuation',
    component: () => import('./containers/NewValuation'),
    children: [],
}, {
    path: '/new-investor-valuation',
    name: 'new_investor_valuation',
    component: () => import('./containers/NewInvestorValuation'),
    children: [],
}];
